import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore';
import { Button, Icon, tk } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';
import { getTableData } from './selectors';
import { useIntl } from '@/intl';
import { downloadCSV } from './utils';

export function DownloadButton() {
  const intl = useIntl();
  const [tableData, tableName] = useGroupResponsibleStore(getTableData, intl);

  const handleDownload = () => {
    if (tableData.length) {
      downloadCSV(tableData, tableName);
    }
  };

  return (
    <>
      <ButtonStyled onClick={handleDownload} $hierarchy="secondary" $withoutColor>
        <Icon glyph="IconDownloadFile" />
        {intl.formatMessage({ id: 'groups_responsible_download' })}
      </ButtonStyled>
      <ButtonStyledSmallScreens onClick={handleDownload} $hierarchy="secondary" $withoutColor>
        <Icon glyph="IconDownloadFile" />
      </ButtonStyledSmallScreens>
    </>
  );
}

const ButtonStyledSmallScreens = styled(Button)`
  display: none;
  @media (max-width: ${tk('breakpoint_desktop_sm')}) {
    display: inline-flex;
  }
`;

const ButtonStyled = styled(Button)`
  @media (max-width: ${tk('breakpoint_desktop_sm')}) {
    display: none;
  }
`;
